import { render, staticRenderFns } from "./FamilyRequest.vue?vue&type=template&id=d99d9dbc&scoped=true&"
import script from "./FamilyRequest.vue?vue&type=script&lang=js&"
export * from "./FamilyRequest.vue?vue&type=script&lang=js&"
import style0 from "./FamilyRequest.vue?vue&type=style&index=0&id=d99d9dbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99d9dbc",
  null
  
)

export default component.exports